import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sort",
  "use": "icon-sort-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sort\"><path d=\"M910.41 435.2l-319.75-319a12.68 12.68 0 0 0-21.64 9v790.46a12.7 12.7 0 0 0 12.69 12.69h38.57A12.7 12.7 0 0 0 633 915.66V265.92a7.69 7.69 0 0 1 13.13-5.43l220.2 220.26a12.69 12.69 0 0 0 18.19-0.25l26.14-27.6a12.61 12.61 0 0 0-0.25-17.7zM442.06 95.65h-39a12.7 12.7 0 0 0-12.69 12.69V758a7.69 7.69 0 0 1-13.11 5.45L156.54 544.07a12.59 12.59 0 0 0-8.94-3.69h-0.24a12.58 12.58 0 0 0-9 4l-25.06 26.76a12.63 12.63 0 0 0 0.3 17.64L433.1 908a12.51 12.51 0 0 0 8.9 3.7 12.86 12.86 0 0 0 4.94-1 12.49 12.49 0 0 0 7.81-11.7V108.34a12.7 12.7 0 0 0-12.69-12.69z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sort.svg
// module id = pr7m
// module chunks = 65